module.exports = __webpack_public_path__ + "static/logo.7a196416.png";